/**
 * @desc 人员模块
 */
const personList = r => require.ensure([],() => r(require('../views/person/PersonList.vue')) ,'personList');

export default [
  //人员列表
  {
    name: 'personList',
    path: '/personList',
    component: personList,
    meta: {title: '人员列表'},
  }
]